import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class ZXReportService extends Service {
    constructor() {
        super();
        this.baseURL = 'reporting/zxreport/';
    }
    async finaliseSaleReport() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "finalise", {
            crossDomain: true,
            method: 'put',
            headers: {'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async getSummary(startDate,endDate, clientAgent) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "summary/" +startDate + "/" + endDate + "/" +clientAgent, {
            crossDomain: true,
            method: 'get',
            headers: {'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async mergeSaleReport(startDate,endDate,clientAgent,reportStartNo,reportEndNo) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "salereport/merge/" + startDate + "/" + endDate + "/" + clientAgent+ "/" + reportStartNo+ "/" + reportEndNo, {
            crossDomain: true,
            method: 'get',
            headers: {'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response,true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}